import React, { useState } from "react";
import { Link } from "react-router-dom";
import { useLanguage } from "@/contexts/LanguageContext";
import { subscribeNewsletter } from "@/lib/api";

export default function Footer() {
  const { t, lang } = useLanguage();
  const [email, setEmail] = useState("");
  const [status, setStatus] = useState("");

  const submit = async (e) => {
    e.preventDefault();
    if (!email) return;
    try {
      await subscribeNewsletter(email);
      setStatus("ok");
      setEmail("");
    } catch (e) {
      setStatus("err");
    }
  };

  return (
    <footer className="bg-[#2C302E] text-[#E5E2DC] mt-24">
      {/* CTA Newsletter */}
      <div className="border-b border-white/10">
        <div className="max-w-7xl mx-auto px-6 md:px-10 lg:px-16 py-16 md:py-24 grid md:grid-cols-2 gap-12 items-center">
          <div>
            <p className="font-heading text-3xl md:text-4xl tracking-tight font-light text-white mb-3">
              {t("cta_title")}
            </p>
            <p className="text-[#A8A8A0] text-base max-w-md leading-relaxed">
              {t("cta_sub")}
            </p>
          </div>
          <form onSubmit={submit} data-testid="newsletter-form" className="flex flex-col sm:flex-row gap-3">
            <input
              type="email"
              required
              data-testid="newsletter-email"
              placeholder={t("cta_email")}
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              className="flex-1 bg-white/5 border border-white/15 rounded-full px-6 py-3.5 text-white placeholder:text-white/40 focus:bg-white/10 focus:outline-none"
            />
            <button
              type="submit"
              data-testid="newsletter-submit"
              className="bg-[#D97B66] hover:bg-[#C66A55] text-white rounded-full px-8 py-3.5 font-medium transition-colors whitespace-nowrap"
            >
              {t("cta_button")}
            </button>
          </form>
          {status === "ok" && (
            <p data-testid="newsletter-thanks" className="text-[#8BA896] text-sm md:col-span-2">
              {t("cta_thanks")}
            </p>
          )}
        </div>
      </div>

      {/* Bottom */}
      <div className="max-w-7xl mx-auto px-6 md:px-10 lg:px-16 py-12 grid grid-cols-2 md:grid-cols-4 gap-10">
        <div className="col-span-2">
          <p className="font-heading text-2xl text-white mb-2">småstund</p>
          <p className="text-sm text-[#A8A8A0] max-w-xs leading-relaxed">
            {t("footer_tagline")}
          </p>
        </div>

        <div>
          <p className="text-xs uppercase tracking-widest text-white/60 mb-4">
            {t("footer_quick")}
          </p>
          <ul className="space-y-2 text-sm text-[#A8A8A0]">
            <li><Link to="/" className="hover:text-white">{t("nav_home")}</Link></li>
            <li><Link to="/butikk" className="hover:text-white">{t("nav_shop")}</Link></li>
            <li><Link to="/om-oss" className="hover:text-white">{t("nav_about")}</Link></li>
          </ul>
        </div>

        <div>
          <p className="text-xs uppercase tracking-widest text-white/60 mb-4">
            {t("footer_legal")}
          </p>
          <ul className="space-y-2 text-sm text-[#A8A8A0]">
            <li>
              <Link to="/personvern" data-testid="footer-link-personvern" className="hover:text-white">
                Personvern
              </Link>
            </li>
            <li>
              <Link to="/vilkar" data-testid="footer-link-vilkar" className="hover:text-white">
                Handelsvilkår
              </Link>
            </li>
            <li>
              <Link to="/cookies" data-testid="footer-link-cookies" className="hover:text-white">
                Cookies
              </Link>
            </li>
          </ul>
        </div>
      </div>

      <div className="border-t border-white/10">
        <div className="max-w-7xl mx-auto px-6 md:px-10 lg:px-16 py-6 text-xs text-[#A8A8A0] flex flex-wrap justify-between gap-3">
          <span>© {new Date().getFullYear()} Småstund. {t("footer_rights")}.</span>
          <span>{lang === "no" ? "Laget i Norge" : "Made in Norway"} ✦</span>
        </div>
      </div>
    </footer>
  );
}
